/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_Point_4Inputs */

const en_backstage_point_4 = /** @type {(inputs: Backstage_Point_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every screen live: no refresh, no stale numbers`)
};

/**
* | output |
* | --- |
* | "Every screen live: no refresh, no stale numbers" |
*
* @param {Backstage_Point_4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_point_4 = /** @type {((inputs?: Backstage_Point_4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_Point_4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_point_4(inputs)
});